import {UIComponent} from "@webfruits/core";
import {CoreServices} from "./CoreServices";
import {Size} from "../style/Size";
import {Font} from "../style/Font";
import {BackgroundSystem} from "../systems/background/BackgroundSystem";
import {IllustrationSystem} from "../systems/illustration/IllustrationSystem";
import {CopySystem} from "../systems/copy/CopySystem";
import {UISystem} from "../systems/ui/UISystem";
import {FactSystem} from "../systems/fact/FactSystem";

/******************************************************************
 * CoreView
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class CoreView extends UIComponent{

    /******************************************************************
     * Properties
     *****************************************************************/

    private _backgroundSystem: BackgroundSystem;
    private _illustrationSystem: IllustrationSystem;
    private _copySystem: CopySystem;
    private _uiSystem: UISystem;
    private _factSystem: FactSystem;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _core: CoreServices) {
        super("basf-infografik");
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public async initSystems() {
        this.initBackgroundSystem();
        this.initIllustrationSystem();
        this.initCopySystem();
        this.initFactSystem();
        this.initUISystem();
    }

    public playIntroAnimation() {
        this._illustrationSystem.playIntroAnimation();
    }

    public updateStyles() {
        this.applyStyle({
            position: "relative",
            width: Size.APP_WIDTH,
            height: Size.APP_HEIGHT,
            color: "red",
            userSelect: "none",
            webkitTouchCallout: "none",
            fontFamily: Font.HELVETICA_REGULAR
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initBackgroundSystem() {
        this._backgroundSystem = new BackgroundSystem();
        this.addChild(this._backgroundSystem);
    }

    private initIllustrationSystem() {
        this._illustrationSystem = new IllustrationSystem(this._core);
        this.addChild(this._illustrationSystem);
    }

    private initCopySystem() {
        this._copySystem = new CopySystem(this._core);
        this.addChild(this._copySystem);
    }

    private initUISystem() {
        this._uiSystem = new UISystem(this._core);
        this.addChild(this._uiSystem);
    }

    private initFactSystem() {
        this._factSystem = new FactSystem(this._core);
        this.addChild(this._factSystem);
    }

    /******************************************************************
     * Events
     *****************************************************************/


}
